/* eslint no-console: 0 */
/* global axios */
/* eslint no-undef: "error" */
/* eslint no-unused-expressions: ["error", { "allowShortCircuit": true }] */
import endPoints from './endPoints';

export default {
  fetchFacebookPages(token, accountId) {
    const urlData = endPoints('fetchFacebookPages');
    urlData.params.omniauth_token = token;
    return axios.post(urlData.url(accountId), urlData.params);
  },
  fetchBusinessToken(clientId, clientSecret, token) {
    const url = 'https://graph.facebook.com/v21.0/oauth/access_token';
    const params = {
      client_id: clientId,
      client_secret: clientSecret,
      code: token,
    };
    return axios.get(url, params);
  },
};
